<template>
  <v-form
    ref="form"
    @submit.prevent="submit"
    align-center
    justify-center
    lazy-validation
    class="mt-4 pb-4"
  >
    <v-card class="login-form">
      <h1 class="headline justify-center">
        {{ $t('signIn.title') }}
      </h1>
      <v-container
        class="py-0 px-0"
        :class="{ 'pt-4': $vuetify.breakpoint.xs }"
      >
        <v-card-text class="py-0 px-0">
          <v-container
            grid-list-md
            class="px-0 pb-0"
            :class="{ 'px-0': $vuetify.breakpoint.xs }"
          >
            <v-layout row>
              <v-flex sm12>
                <v-text-field
                  name="Email"
                  :label="$t('common.fields.login') + ' *'"
                  id="login"
                  v-model="credentials.login"
                  type="email"
                  :rules="rules.login"
                  required
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex sm12>
                <v-text-field
                  name="Password"
                  :label="$t('common.fields.password') + ' *'"
                  id="password"
                  v-model="credentials.password"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  :type="showPassword ? 'text' : 'password'"
                  :rules="rules.password"
                  @click:append="showPassword = !showPassword"
                  required
                />
              </v-flex>
            </v-layout>
            <v-layout row justify-end>
              <v-btn
                :disabled="isLoading"
                :to="{ name: 'forgot' }"
                :ripple="false"
                color="warning"
                class="mb-4"
                text
                depressed
              >
                {{ $t('common.btns.forgotPassword') }}
              </v-btn>
            </v-layout>
            <!-- Alert -->
            <v-layout row v-if="errorAlert.state">
              <v-flex sm12>
                <v-alert :value="errorAlert.state" type="error">{{
                  errorAlert.message
                }}</v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout align-center class="btns-wrapper">
            <v-btn
              type="submit"
              color="warning mt-2"
              :disabled="isLoading"
              large
              depressed
            >
              {{ $t('common.btns.signIn') }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-form>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'LoginForm',
  components: {},
  data() {
    return {
      credentials: {
        login: '',
        password: '',
      },
      showPassword: false,
      isLoading: false,
      rules: {
        login: [
          /* eslint-disable*/
          (v) =>
            !!v || this.$root.$t('common.fields.validation.field.required'),
          (v) =>
            /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
              v,
            ) || this.$root.$t('common.fields.validation.email'),
        ],
        password: [
          /* eslint-disable*/
          (v) =>
            !!v || this.$root.$t('common.fields.validation.field.required'),
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      errorAlert: 'global/getAlertError',
    }),
  },
  destroyed() {
    this.clearAlertError();
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      getMyInfo: 'auth/getMyInfo',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
    }),
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.isLoading = true;
      try {
        await this.login(this.credentials);

        this.clearAlertError();
        this.$refs.form.reset();

        if (this.$store.getters['global/getRole'] === 'investor') {
          this.$router.push({ name: 'investor-board-list' });
        } else if (this.$store.getters['global/getRole'] === 'mechanic') {
          this.$router.push({ name: 'mechanic-rents' });
        } else {
          this.$router.push({ name: 'workers-board-list' });
        }
      } catch (error) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.login-form {
  max-width: 370px;
  margin: 0 auto;
  margin-top: 70px;
  padding: 0 50px;

  @media (max-width: 599px) {
    margin-top: 35px;
  }

  .headline {
    text-align: center;
    font-weight: 700;
    font-size: 30px !important;
    padding-top: 50px;
    padding-bottom: 10px;
    color: #ff8a1f;
  }

  .btns-wrapper {
    justify-content: space-around;
    a {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
    button {
      margin-bottom: 34px;
    }
  }
}
</style>
